module.exports = __webpack_public_path__ + "static/media/arrow-right-outline.3c54d717.svg";